/* global globalThis */
import {FINAL_ROUND} from "../../../configs/game";
import {UNIT_TYPES} from "../../../configs/units";

// Волна 32, блок «Армия и монеты». Прод, 282 реплея: армия бота застывает на
// 15-17 с 8 раунда (у людей-победителей растет до 33); 36% отрядов бота в R9-13
// уже на максимуме размера, 44% из них d6.
// Волна 32, раунд 3: A/B r2 дал минус по очкам у слотов армии с фермами под нее
// (A1/A2) и у докупки размера в R6-9 с бюджетом раунда 13 (A3/A4) — эти части
// удалены вместе с гейтами isPreW32ArmyPlayer/isPreW32ArmySpendPlayer. Остается
// улучшение отрядов A5 (гейт isPreW32ArmyUpgradePlayer, abTestGates).
// Калибровка в симуляции: globalThis.__w32ArmyConfig (в проде не задается)
export const W32_ARMY_CONFIG = Object.freeze({
  upgradeFromRound: 5,            // A5
  upgradeCoinFloor: 4,
});

// A5: какие улучшения и с какого размера (размер сохраняется, лимит растет)
export const W32_UNIT_UPGRADE_RULES = Object.freeze([
  {fromId: UNIT_TYPES.D6.id, toId: UNIT_TYPES.D10.id, minSize: 4, lastRound: FINAL_ROUND - 2},
  {fromId: UNIT_TYPES.D8.id, toId: UNIT_TYPES.D12.id, minSize: 6, lastRound: FINAL_ROUND - 2},
  {fromId: UNIT_TYPES.D10.id, toId: UNIT_TYPES.D20.id, minSize: 8, lastRound: FINAL_ROUND - 3},
]);

export const getW32ArmyConfig = () => (globalThis.__w32ArmyConfig
  ? {...W32_ARMY_CONFIG, ...globalThis.__w32ArmyConfig}
  : W32_ARMY_CONFIG);

// A5: улучшение уступает докупке размера защитнику угрожаемого города. Улучшение
// размера в этом раунде не дает, а докупка дает; улучшать можно самого защитника
// (размер этого раунда тот же, лимит выше), но не другой отряд, пока защитнику
// нужны монеты. threatenedDefenders — свои отряды на казармах угрожаемых городов:
// [{id, size, maxSize, hasEnemyInReach}]; почти полный отряд без врага в 3 клетках
// размер не докупает (волна 19, 18.5) — ему монеты не нужны
export const checkIfW32UpgradeYieldsToDefender = ({candidateUnitId, threatenedDefenders}) =>
  (threatenedDefenders || []).some((defender) => {
    if (defender.id === candidateUnitId) {
      return false;
    }
    const isNearFull = defender.size >= defender.maxSize * 0.8 || defender.size > defender.maxSize - 2;
    return !isNearFull || Boolean(defender.hasEnemyInReach);
  });

// A5: вариант улучшения; availableUpgrades — getAvailableUnitUpgrades(unit.type, unit.factionId)
export const pickW32UnitUpgrade = (
  {unitType, unitSize, round, availableUpgrades, isEconomicArchetype, ownD20Count},
  config = W32_ARMY_CONFIG,
  rules = W32_UNIT_UPGRADE_RULES
) => {
  if (!round || round < config.upgradeFromRound) return null;
  const rule = rules.find((candidate) => candidate.fromId === unitType);
  if (!rule || round > rule.lastRound || !(unitSize >= rule.minSize)) return null;
  // Волна 19 (18.10): экономический архетип с 2 d20 новых d20 не получает
  if (rule.toId === UNIT_TYPES.D20.id && isEconomicArchetype && ownD20Count >= 2) return null;
  return (availableUpgrades || []).find((option) => option.toId === rule.toId) || null;
};
